<template>
  <div class="big-box">
    <div class="contents" v-if="projectList.project_avalible != null && projectList.project_avalible.length > 0">
      <div class="title"></div>
      <el-table :data="projectList.project_avalible" class="form-table">
        <el-table-column prop="title" label="考试名称"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="switchProject(scope.row.id)">开始报考</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="contents" v-if="projectList.project_in != null && projectList.project_in.length > 0">
      <div class="title"></div>
      <el-table :data="projectList.project_in">
        <el-table-column prop="title" label="考试名称"></el-table-column>
        <el-table-column prop="title" label="报考情况">
          <template v-slot="scope">
            <span style="color: red;" v-if="scope.row.apply.status == '-1'">{{ scope.row.apply.message }}</span>
            <span style="color: red;" v-else-if="scope.row.apply.status == '-2'">{{ scope.row.apply.message }}</span>
            <span style="color: red;" v-else>{{ scope.row.apply.process_message }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <router-link tag="button" class="el-button apply-button el-button--default" :to="{ path: '/apply', query: { id: scope.row.id } }">
              继续报考
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="contents" v-if="projectList.project_finish != null && projectList.project_finish.length > 0">
      <div class="title"></div>
      <el-table :data="projectList.project_finish">
        <el-table-column prop="title" label="考试名称"></el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <router-link tag="button" class="el-button el-button--default" :to="{ path: '/scoreDetail', query: { id: scope.row.id } }">
              查看成绩
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="contents" v-if="noAvailableProjects">
      <div class="no-projects-message">暂无考试项目</div>
    </div>

    <el-dialog title="信息确认" :visible.sync="centerDialogVisible" width="50%" center :modal="false">
      <span>请仔细核对照片和姓名，确认后不能再修改，如因此影响考试报名，后果自负</span>
      <span slot="footer" class="dialog-footer">
        <router-link tag="button" class="el-button apply-button el-button--default" :to="{ path: '/apply', query: { id: project_id } }">
          开始报考
        </router-link>
        <el-button type="primary" @click="routeHop('/home')">去修改个人资料</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { reqProjectList, reqProjectDetail } from "@/api";
import { mapState, mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";
export default {
  inject: ["reload"],
  computed: {
    ...mapState(useMainStore, {
      userInfo: "getUserInfo",
    }),
    noAvailableProjects() {
      return (
        (!this.projectList.project_avalible || this.projectList.project_avalible.length === 0) &&
        (!this.projectList.project_in || this.projectList.project_in.length === 0)
      );
    },
  },
  data() {
    return {
      projectList: [],
      projectDetail: [],
      project_id: "",
      centerDialogVisible: false,
    };
  },

  mounted() {
    this.getProjectList();
    if (!this.$cookies.get("token")) {
      this.token("");
      this.changUser({});
      this.changUserCert({});
      this.changeProject([]);
      this.$router.push("/login");
    }
  },

  methods: {
    ...mapActions(useMainStore, {
      token: "updateToken",
      changeProject: "updateProjectDetail",
      changUser: "updateUserInfo",
      changUserCert: "updateUserCertInfo",
    }),
    routeHop(url) {
      this.$router.push(url);
    },
    confirm() {
      this.dialogVisible = true;
    },
    switchProject(project_id) {
      this.project_id = project_id;
      this.centerDialogVisible = true;
    },
    continueProject(project_id) {
      let that = this;
      that.project_id = project_id;
    },
    getProjectList() {
      let that = this;
      reqProjectList(that.user_id).then((res) => {
        if (res.data.code === 1) {
          that.projectList = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.big-box {
  width: 82%;
  margin-left: 9%;
}

.contents {
  margin-top: 100px;
  margin-bottom: 30px;
  background: white;
  border-radius: 6px;
  padding: 30px;
}

.form-table {
  min-width: 800px;
}

.apply-button:hover {
  transform: scale(1.1);
  cursor: pointer;
  border-radius: 3px;
}

.apply-button {
  background-color: #f5606a;
  border: none;
  color: rgb(251, 250, 250);
  font-size: 12px;
  border-radius: 3px;
  font-weight: 350;
}

.inline-con {
  width: 100%;
  margin-top: 30px;
}

.contents {
  margin-top: 30px;
}

.title {
  margin-bottom: 20px;
  font-size: 18px;
  color: #ccc;
  font-weight: bolder;
}

.no-projects-message {
  text-align: center;
  font-size: 20px;
  margin-top: 50px;
}
</style>